export default __webpack_public_path__ + "static/media/android.463d31bf.png";